import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Checkbox } from '@mui/material';
import type { CheckableItemView } from '../../../../../services/MedNecService';

interface CheckableListProps {
  title: string;
  items: CheckableItemView[];
  onToggle: (index: number) => void;
}

const CheckableList: React.FC<CheckableListProps> = ({ title, items, onToggle }) => {
  if (items.length === 0) return null;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>{title}</Typography>
      <List dense>
        {items.map((item, i) => (
          <ListItem key={i} sx={{ py: 0.25 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Checkbox
                size="small"
                checked={item.isChecked}
                onChange={() => onToggle(i)}
                sx={{ p: 0.25 }}
              />
            </ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{
                variant: 'body2',
                sx: item.isChecked ? { textDecoration: 'line-through', color: 'text.secondary' } : {},
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default CheckableList;
